export default __webpack_public_path__ + "72899a9f1c6eeb88f67ae32a44487361.svg";